import { useEffect, useState } from 'react';
import PageHeader from '../../../../../Layouts/PageHeader/PageHeader';
import { useDispatch, useSelector } from 'react-redux';
import {
    MissionStore,
    setEdge,
    setEdgeSelected,
    setEditEdgeData,
    setIsEdgeEdit,
} from '../../../../../store/MissionSlice';
import EdgeSlider from './EdgeSlider';
import CatalogueService from '../../../../../service/CatalogueService';
import { Steps } from '../../Stepper.constants';
import { useNavigate, useParams } from 'react-router-dom';
import { calculateEdgeUsage, calculate_Total_AOP_Usage, navigateTo, onKeyDown, isInvalidMinMaxRange } from '../../../../../utils/commonFunctions';
import CloseButton from '../../../../CommonComponents/CloseButton';
import { Button, Form } from 'react-bootstrap';
import MissionService from '../../../../../service/MissionService';
import Loader from '../../../../../Layouts/Loader/Loader';
import CustomSelect from '../../../../CommonComponents/CustomSelect';
import { showToastMessage } from '../../../../../utils/commonFunctions';

const MIN_MAX_VALIDATION_MSG = 'Minimum value cannot exceed Maximum value';

const Edge = () => {
    const params = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mission_name, sat_name, mission_id, sat_id, edge_id } = params

    const isEdgeSelected = useSelector((state: { mission: MissionStore }) => state.mission.isEdgeSelected);
    const isEditEdgeData = useSelector((state: { mission: MissionStore }) => state.mission.isEditEdgeData);
    const [EdgeList, setEdgeList] = useState<any[]>([]);
    const [filterEdgeList, setFilterEdgeList] = useState<any[]>([]);
    const [filterOptions, setFilterOptions] = useState<any>({});
    const [filterOptionsValues, setFilterOptionsValues] = useState<any>(
        {
            'GPU': null,
            'Memory': {
                min: '',
                max: ''
            },
            'Memory Type': null,
            'Storage': {
                min: '',
                max: ''
            },
            'Power': {
                min: '',
                max: ''
            },
            'CPU': {
                min: '',
                max: ''
            }
        }
    );
    const [satEdges, setSatEdges] = useState<any[]>([]);
    const EditEdgeData = useSelector((state: { mission: MissionStore }) => state.mission.EditEdgeData);
    const [selectedEdgeId, setSelectedEdgeId] = useState<any>('');
    const [payloads, setPayloads] = useState([])
    const [edges, setEdges] = useState([])
    const [loading, setLoading] = useState(true);
    const [hover, setHover] = useState(true)
    const [satName, setSatName] = useState("")

    const filter_unique_values = (arr) => {
        const uniqueValues = {};
        const uniqueArr = arr.filter(item => {
            if (!uniqueValues[item.label]) {
                uniqueValues[item.label] = true;
                return true;
            }
            return false;
        });

        return uniqueArr;
    }

    const getAllEdges = (message?: string) => {
        const response = CatalogueService.getCatalogue('Edge', 'Edge Node')
        response?.then((data) => {
            if (data.data) {
                let options = {
                    'GPU': [],
                    'Memory Type': [],
                }
                setEdgeList(data.data)
                setFilterEdgeList(data.data)
                data.data.forEach((edge) => {
                    if (edge?.['product-cookie']?.['GPU'] !== 'n/a') {
                        options = {
                            ...options,
                            'GPU': filter_unique_values([
                                ...options?.['GPU'],
                                { label: edge?.['product-cookie']?.['GPU'], value: edge?.['product-cookie']?.['GPU'] }
                            ]),
                            'Memory Type': filter_unique_values([
                                ...options?.['Memory Type'],
                                { label: edge?.['product-cookie']?.['Memory Type'], value: edge?.['product-cookie']?.['Memory Type'] }
                            ]),
                        }
                        setFilterOptions(options)
                    }
                })
                if (message) {
                    showToastMessage('success', message)
                }
            }
        }).catch((err) => {
            console.log(err.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        getAllEdges()
    }, []);

    useEffect(() => {
        if (sat_id) {
            MissionService.get_satellite_by_sat_id(sat_id, mission_id)?.then((sat) => {
                if (sat?.data) {
                    setSatName(sat?.data?.name)
                    MissionService.get_payload_by_sat_id(sat_id, mission_id)?.then((payalod) => {
                        MissionService.get_edge_by_sat_id(sat_id, mission_id)?.then((edge) => {
                            const all_payloads = payalod?.data ? payalod?.data : []
                            const all_edges = edge?.data ? edge?.data : []
                            setPayloads(all_payloads)
                            setEdges(all_edges)
                            calculateEdgeUsage(all_edges, dispatch) //swap info calculation for edge
                            calculate_Total_AOP_Usage(all_payloads, all_edges, dispatch) //swap info calculation for power
                            if (edge_id && edge_id !== undefined) {
                                let edit_edge = all_edges.find(edg => edg?.['edge-id'] == edge_id)
                                dispatch(setEditEdgeData(edit_edge));
                                dispatch(setIsEdgeEdit(true));
                            }
                        }).catch((err) => {
                            showToastMessage('error', "Error in getting edge");
                        })
                    }).catch((err) => {
                        showToastMessage('error', "Error in getting payload");
                    })
                }
            }).catch((err) => {
                console.log('Some thing went wrong while getting satellite');
            })
        }
    }, [sat_id]);

    const reset_filter = () => {
        setFilterOptionsValues(
            {
                'GPU': null,
                'Memory': {
                    min: '',
                    max: ''
                },
                'Memory Type': null,
                'Storage': {
                    min: '',
                    max: ''
                },
                'Power': {
                    min: '',
                    max: ''
                },
                'CPU': {
                    min: '',
                    max: ''
                }
            }
        )
        setFilterEdgeList(EdgeList)
    }

    const applyMinMaxFilter = (
        list: any[],
        range: { min?: string | number; max?: string | number } | null | undefined,
        getValue: (item: any) => number | null | undefined
    ): any[] => {
        if (!range || isInvalidMinMaxRange(range?.min, range?.max)) return list;

        let result = list;
        const min = range?.min ?? '';
        const max = range?.max ?? '';

        if (min !== '') {
            result = result.filter((item) => {
                const value = getValue(item);
                return value != null && +value >= +min;
            });
        }

        if (max !== '' && +max >= +(min || 0)) {
            result = result.filter((item) => {
                const value = getValue(item);
                return value != null && +value <= +max;
            });
        }

        return result;
    }

    const applyEdgeFilters = (values: typeof filterOptionsValues): any[] => {
        let result = EdgeList || [];
        const {
            CPU: cpu,
            Memory: memory,
            Storage: storage,
            Power: power,
            GPU: gpu,
            "Memory Type": memoryType,
        } = values || {};
        result = applyMinMaxFilter(result, cpu, (d) => d?.["product-cookie"]?.["CPU Cores"])
        result = applyMinMaxFilter(result, memory, (d) => d?.["product-cookie"]?.["Memory"]?.split(' ')?.[0])
        result = applyMinMaxFilter(result, storage, (d) => d?.["product-cookie"]?.["Storage"]?.split(' ')?.[0])
        result = applyMinMaxFilter(result, power, (d) => d?.["max_power_consumption_in_watts"])
        if (gpu != null) result = result.filter((d) => d?.["product-cookie"]?.["GPU"] === gpu?.value);
        if (memoryType != null) result = result.filter((d) => d?.["product-cookie"]?.["Memory Type"] === memoryType?.value);
        return result;
    };

    const handleMinMaxBlur = (field: 'CPU' | 'Memory' | 'Storage' | 'Power') => {
        const min = filterOptionsValues?.[field]?.min;
        const max = filterOptionsValues?.[field]?.max;
        if (isInvalidMinMaxRange(min, max)) {
            showToastMessage('error', MIN_MAX_VALIDATION_MSG);
            setFilterOptionsValues((prev) => ({
                ...prev,
                [field]: { ...prev?.[field], max: '' },
            }));
            const nextValues = { ...filterOptionsValues, [field]: { min: min ?? '', max: '' } };
            setFilterEdgeList(applyEdgeFilters(nextValues));
        }
    };

    const onSelectEdge = (data) => {
        dispatch(setEdge(data));
        setSelectedEdgeId(data['uniqueId'])
        dispatch(setEdgeSelected(true));
    };


    useEffect(() => {
        if (isEditEdgeData) {
            if (EditEdgeData) {
                setSelectedEdgeId(EditEdgeData?.['edge-device']?.['atmos-data']?.['uniqueId']);
                onSelectEdge(EditEdgeData?.['edge-device']?.['atmos-data']);
            }
        } else {
            setSelectedEdgeId('');
        }
    }, [isEditEdgeData]);

    const navigate_to_step = (step) => {
        if (isEditEdgeData || isEdgeSelected) {
            dispatch(setEdge({}));
            dispatch(setEdgeSelected(false));
            dispatch(setIsEdgeEdit(false));
            dispatch(setEditEdgeData({}));
        }
        if (step === 'Payloads') {
            navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`, navigate)
        }
        if (step === 'Bus Design') {
            navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_template`, navigate)
        }
    }


    return (
        <div className='h-100 w-100 '>
            {loading && <Loader className='z-9999' />}
            <PageHeader
                titles="Configure Edge Device"
                description="Edge device is a compute node used to perform specialized data processing like encryption, compression, etc."
                active="New Mission"
                items={['Apps']}
                sat_name={satName}
                isButton={false}
                showSwap={true}
                showPercent={false}
                type=''
                value=''
            />
            <div className='d-flex flex-wrap h-80 w-100'>
                <div className='d-flex w-100 h-100'>
                    <div className='w-20 d-flex p-5 overflow-y-scroll h-100 flex-column gap-3 position-relative'>
                        <div className='d-flex flex-column gap-2'>
                            <span className="">CPU / RT Cores</span>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Minimum'
                                    value={filterOptionsValues['CPU']?.['min']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const cpuMinValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'CPU': { ...filterOptionsValues['CPU'], min: cpuMinValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('CPU')}
                                />
                                <span>-</span>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Maximum'
                                    value={filterOptionsValues['CPU']?.['max']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const cpuMaxValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'CPU': { ...filterOptionsValues['CPU'], max: cpuMaxValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('CPU')}
                                />
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-2'>
                            <span className="">Memory</span>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Minimum'
                                    value={filterOptionsValues['Memory']?.['min']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const memoryMinValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Memory': { ...filterOptionsValues['Memory'], min: memoryMinValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Memory')}
                                />
                                <span>-</span>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Maximum'
                                    value={filterOptionsValues['Memory']?.['max']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const memoryMaxValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Memory': { ...filterOptionsValues['Memory'], max: memoryMaxValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Memory')}
                                />
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-2'>
                            <span className="">Storage</span>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Minimum'
                                    value={filterOptionsValues['Storage']?.['min']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const storageMinValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Storage': { ...filterOptionsValues['Storage'], min: storageMinValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Storage')}
                                />
                                <span>-</span>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Maximum'
                                    value={filterOptionsValues['Storage']?.['max']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const storageMaxValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Storage': { ...filterOptionsValues['Storage'], max: storageMaxValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Storage')}
                                />
                            </div>
                        </div>
                        {Object.keys(filterOptions).length > 0 && Object.keys(filterOptions).map((key, index) => {
                            return (
                                <div className='d-flex flex-column gap-2' key={index}>
                                    <span className="">{key}</span>
                                    <CustomSelect
                                        background='rgba(10, 10, 10, 0.65)'
                                        options={filterOptions?.[key]}
                                        value={filterOptionsValues[key]}
                                        placeholder={"Select " + key}
                                        onChange={(e: any) => {
                                            const next = { ...filterOptionsValues, [key]: e };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        }}
                                    />
                                </div>
                            )
                        })}
                        <div className='d-flex flex-column gap-2'>
                            <span className="">Peak Power</span>
                            <div className='d-flex align-items-center gap-2'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Minimum'
                                    value={filterOptionsValues['Power']?.['min']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const powerMinValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Power': { ...filterOptionsValues['Power'], min: powerMinValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Power')}
                                />
                                <span>-</span>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    placeholder='Maximum'
                                    value={filterOptionsValues['Power']?.['max']}
                                    onKeyDown={onKeyDown}
                                    onChange={(e: any) => {
                                        if (!isNaN(e.target.value) && e.target.value.length <= 5) {
                                            const powerMaxValue = e.target.value;
                                            const next = { ...filterOptionsValues, 'Power': { ...filterOptionsValues['Power'], max: powerMaxValue } };
                                            setFilterOptionsValues(next);
                                            setFilterEdgeList(applyEdgeFilters(next));
                                        } else if (e.target.value.length > 5) {
                                            showToastMessage('info', "Maximum 5 digits allowed");
                                        }
                                    }}
                                    onBlur={() => handleMinMaxBlur('Power')}
                                />
                            </div>
                        </div>
                        <div className='w-90 d-flex justify-content-center position-absolute bottom-0 mb-2'>
                            <button className='btn btn-outline-primary px-8 fs-18' onClick={reset_filter}>Reset</button>
                        </div>
                    </div>
                    <span className='border-left-3 h-100'></span>
                    <div className="flex-1 d-flex flex-wrap edge-cards overflow-y-scroll py-5 ms-5">
                        {filterEdgeList?.length > 0 && filterEdgeList?.map((data, i) => {
                            return <div className={data['uniqueId'] === selectedEdgeId ? 'common-card-box h-365 active' : 'common-card-box h-365'}
                                key={i} onClick={() => {
                                    onSelectEdge(data);
                                }}>
                                <div className="common-card-header pe-0">
                                    <div className="W-90 text-truncate" title={data?.["name"]}>
                                        <h4 className="mb-2 text-truncate">{data?.["name"]}</h4>
                                    </div>
                                </div>
                                <div className="common-card-content">
                                    <div className="d-flex flex-wrap">
                                        <div className="stats-alpha">
                                            <strong>{data['product-cookie']['CPU Cores']}</strong>
                                            <span>CPU Cores</span>
                                        </div>
                                        {data?.['product-cookie']?.['GPU'] !== 'n/a' &&
                                            <div className="stats-alpha lg">
                                                <strong>{data['product-cookie']['GPU']}</strong>
                                                <span>GPU</span>
                                            </div>
                                        }
                                        <div className="stats-alpha">
                                            <strong>{data['product-cookie']['Memory']}</strong>
                                            <span>Memory</span>
                                        </div>
                                        <div className="stats-alpha">
                                            <strong>{data['product-cookie']['Memory Type']}</strong>
                                            <span>Memory Type</span>
                                        </div>
                                        <div className="stats-alpha lg">
                                            <strong>{data['product-cookie']['Storage']}</strong>
                                            <span>Storage</span>
                                        </div>
                                        <div className="stats-alpha">
                                            <strong>{data['max_power_consumption_in_watts'] + ' W'}</strong>
                                            <span>Peak Power</span>
                                        </div>
                                        <div className="stats-alpha">
                                            <strong>{data['product-cookie']['Performance']}</strong>
                                            <span>Performance</span>
                                        </div>
                                    </div>
                                </div>
                            </div>;
                        })}
                    </div>
                </div>
            </div>

            <div className="navigator-btn gap-3">
                {!isEditEdgeData && <CloseButton />}
                {isEditEdgeData && <Button
                    variant="primary-outline"
                    type="button"
                    className="btn btn-outline-danger pt-1 pb-1 pe-6 ps-6 me-2 fs-14"
                    onClick={() => {
                        dispatch(setIsEdgeEdit(false));
                        dispatch(setEditEdgeData({}));
                        navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
                    }}
                >
                    Cancel
                </Button>}
                <div className="btn-group btn-grp-nav">
                    <Button
                        variant={hover ? "outline-primary" : "primary"}
                        type="button"
                        className={`d-flex align-items-center btn ${hover ? "btn-outline-primary" : "btn-primary"
                            } pt-1 pb-1 pe-4 ps-3 fs-14`}
                        onClick={() => {
                            if (satEdges?.length > 0) {
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
                            } else {
                                navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`, navigate)
                            }
                        }}
                        onMouseEnter={() => {
                            setHover(false);
                        }}
                        onMouseLeave={() => {
                            setHover(true);
                        }}
                    >
                        <i className="fe fe-chevron-left me-1 fs-16"></i> Back
                    </Button>
                    <Button
                        variant={hover ? "primary" : "outline-primary"}
                        type="submit"
                        className={`d-flex align-items-center btn ${hover ? "btn-primary" : "btn-outline-primary"
                            } pt-1 pb-1 pe-3 ps-4 fs-14`}
                        onClick={() => {
                            navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_template`, navigate)
                        }}
                    >
                        {satEdges?.length > 0 ? 'Next' : 'Skip'}
                        <i className="fe fe-chevron-right ms-1 fs-16"></i>
                    </Button>
                </div>
            </div>

            <div className="stepper-container">
                <div className="breadcrumb">
                    {Steps.map((data) => {
                        return <a
                            onClick={() => { navigate_to_step(data.title) }}
                            className={data.title === 'Edge' ? 'active' : ''}
                            key={data.title}>
                            <span className={"breadcrumb__inner"}>
                                <span className="breadcrumb__title">
                                    {data.svg}
                                </span>
                                <span className="breadcrumb__desc">{data.title}</span>
                            </span>
                        </a>
                    })}
                </div>
            </div>

            {isEdgeSelected && <EdgeSlider setSatEdges={setSatEdges} selectedEdgeId={selectedEdgeId} setSelectedEdgeId={setSelectedEdgeId} allEdges={edges} allPayloads={payloads} setLoading={setLoading} />}
        </div>
    )
};
export default Edge;

